import { useContext } from "react";

import { MainLayoutContext } from "./MainLayoutContext";

export const useMainLayoutProvider = () => {
  const mainLayout = useContext(MainLayoutContext);

  if (!mainLayout) {
    throw new Error(
      "useMainLayoutProvider must be used within a MainLayoutProvider",
    );
  }

  return mainLayout;
};
